import { AnalyticsBrowser } from '@segment/analytics-next';
import { signInCheck } from '../../../components/common/CheckUserStatus';
import { readCookie, createCookie, readCohortValueCookie } from '../../../components/common/Cookie';
import endpoints from '../../../modules/ajio-util/endpoints';
import {
  getSegmentTrackingEnabledFlag,
  getAffiliateFeatureConfig,
  getCreatorProgramConfig,
  getAffiliateAttributionWindow,
  getYoutubeAffiliateAttributionWindow
} from '../../../refresh/selectors/featureFlagsSelector';
import { getAffiliateCookie, setAffiliateCookie } from '../../../utils/affiliateUtils';
import { amplitudeIdentify, amplitudeSetDeviceId, getNewRepeatVisitor } from './amplitude';

const CryptoJS = require('crypto-js');

const segmentTrackingEnabled = getSegmentTrackingEnabledFlag(window?.__PRELOADED_STATE__?.flags);
const isAffiliateFeatureEnabled = getAffiliateFeatureConfig(window?.__PRELOADED_STATE__);
const isCreatorFeatureEnabled = getCreatorProgramConfig(window?.__PRELOADED_STATE__);
const affiliateAttributionWindow = getAffiliateAttributionWindow(window?.__PRELOADED_STATE__);
const youtubeAffiliateAttributionWindow = getYoutubeAffiliateAttributionWindow(window?.__PRELOADED_STATE__);
const segment_api_write_key = endpoints.getProperties('segment_api_write_key');
const cleverTapId = endpoints.getProperties('cleverTapID');
const AFFILIATE_KEYS = [
  'attributed_affiliate_name',
  'attributed_affiliate_id',
  'attributed_affiliate_campaign_id',
  'attributed_affiliate_click_id',
  'attributed_affiliate_sub_id',
  'attributed_affiliate_additional_publisher_info',
  'attributed_affiliate_campaign_name',
  'attributed_affiliate_campaign_medium'
];
export const analytics = new AnalyticsBrowser();

console.log('segmentTrackingEnabled', segmentTrackingEnabled);
console.log(
  'Affiliate logs: [segment.js][module-init] STEP 1 - affiliateFeatureConfig:',
  isAffiliateFeatureEnabled,
  'creatorFeatureConfig:',
  isCreatorFeatureEnabled,
  'attributionWindow(hours):',
  affiliateAttributionWindow
);
if (segmentTrackingEnabled == 'ON') {
  // Set affiliate/creator cookie before identity call so traits include attribution data
  const affiliateConfigForCookie = {
    ...(isAffiliateFeatureEnabled || {}),
    attributionWindow: affiliateAttributionWindow,
    youtubeAttributionWindow: youtubeAffiliateAttributionWindow
  };
  console.log(
    'Affiliate logs: [segment.js][module-init] STEP 2 - calling setAffiliateCookie with config:',
    affiliateConfigForCookie,
    'creatorEnabled:',
    !!isCreatorFeatureEnabled?.masterFlag
  );
  if (isCreatorFeatureEnabled?.masterFlag) {
    setAffiliateCookie(affiliateConfigForCookie, isCreatorFeatureEnabled);
  } else {
    setAffiliateCookie(affiliateConfigForCookie, {});
  }
  (async () => {
    await analytics.load({ writeKey: segment_api_write_key });
    const serverDeviceId = readCookie('segment_device_id');
    if (serverDeviceId) {
      analytics.setAnonymousId(serverDeviceId);
    }
    setUserDetails();
  })();
}

function setUserDetails() {
  setTimeout(async () => {
    const user = await analytics.user();
    // Treat the segment_device_id cookie (set by the Node middleware on first
    // visit and persisted thereafter) as the source of truth. Never overwrite
    // it with user.anonymousId(), which can drift to the SDK's auto-generated
    // value if setAnonymousId hasn't yet taken effect.
    const anonymousId = readCookie('segment_device_id') || user.anonymousId();

    createCookie('segment_user_id', user.id() || '');
    createCookie('segment_device_id', anonymousId);
    // Sync Amplitude device_id with the cookie value so guest events share
    // an identifier across both platforms.
    amplitudeSetDeviceId(anonymousId);
  }, 10);
}

function sha256Hex(message) {
  if (!message) return '';

  const hash = CryptoJS.SHA256(message);
  return hash.toString(CryptoJS.enc.Hex);
}

export const segmentReset = () => {
  try {
    analytics?.reset();
    const deviceId = readCookie('segment_device_id') || '';
    if (deviceId) analytics?.setAnonymousId(deviceId);
  } catch (e) {
    // analytics not loaded yet — nothing to reset.
  }
};

export function segmentTrackUser(profileResponse, otherDetails) {
  
    if (profileResponse) {
      const customerType = readCookie('customerType') || 'new';
      const isNew = customerType?.toLowerCase() === 'new';
      const pincode = readCookie('PC');
      const storeName = window?.__PRELOADED_STATE__?.metaData?.name || '';
      const city = (readCookie('CT') || '').toLowerCase();
      const region = (readCookie('ZN') || '').toLowerCase();
      let funtionTriggered = 0;
      let hasIdentityEventFired = false;

      const hashDigest = sha256Hex(profileResponse.customerUuid);

      const triggerIdentityEvent = () => {
        if (hasIdentityEventFired) return;

        if (
          (!readCohortValueCookie('userCohortValues', storeName, 'cms') ||
            !readCookie('PC') ||
            !readCookie('CT') ||
            !readCookie('ZN') ||
            !readCookie("customerType")) &&
          funtionTriggered <= 9
        ) {
          setTimeout(() => {
            triggerIdentityEvent();
            funtionTriggered += 1;
          }, 1000);

          return;
        }
        const traits = {
          customer_pk: sha256Hex(profileResponse.pk),
          name: sha256Hex(profileResponse.name?.toLowerCase()),
          email: sha256Hex(profileResponse.uid?.toLowerCase()),
          mobileNumber: sha256Hex(profileResponse.mobileNumber),
          cleverTap_Id: cleverTapId || '',
          new_repeat_customer_flag: isNew,
          new_repeat_customer_type: isNew ? 'New' : 'Existing',
        new_repeat_visitor: getNewRepeatVisitor(),
          ...(pincode && { pincode }),
          ...(readCohortValueCookie('userCohortValues', storeName, 'cms') && {
            customer_cohort: readCohortValueCookie('userCohortValues', storeName, 'cms')
          }),
          ...(city && { city }),
          ...(region && { region })
        };
        const affiliateData = getAffiliateCookie();
        console.log('Affiliate logs: [segment.js][trackUser] cookie:', affiliateData);
        // 🔥 ALWAYS reset affiliate traits (even if no affiliateData present)
        AFFILIATE_KEYS.forEach(key => {
          traits[key] = 'NA';
        });

        // ✅ Add fresh affiliate/creator data only if available + matching channel enabled
        const medium = affiliateData?.attributed_affiliate_campaign_medium;
        const isChannelEnabled =
          medium === 'creator'
            ? isCreatorFeatureEnabled?.masterFlag
            : true;
        console.log(
          'Affiliate logs: [segment.js][trackUser] medium/enabled:',
          medium,
          isChannelEnabled
        );
        if (isChannelEnabled && affiliateData && Object.keys(affiliateData).length > 0) {
          Object.assign(traits, affiliateData);
          console.log('Affiliate logs: [segment.js][trackUser] merged affiliate traits');
        }
        console.log('Affiliate logs: [segment.js][trackUser] final traits:', traits);
        amplitudeIdentify(hashDigest, traits);
        if(segmentTrackingEnabled == "ON"){
          analytics?.identify(hashDigest, traits);
        }
        setUserDetails();
        hasIdentityEventFired = true;
      };

      triggerIdentityEvent();
    }
}

function getCustomerUUID() {
  const userUUID = readCookie('CI');
  return userUUID ? decodeURIComponent(userUUID) : '';
}

//check on load
if (signInCheck()) {
  const customerUUI = getCustomerUUID();
  const customerType = readCookie('customerType') || 'new';
  const emailId = readCookie('U');
  const customer_pk = readCookie('PK');
  const mobileNumber = readCookie('MN');
  const name = readCookie('un');
  const isNew = customerType?.toLowerCase() === 'new';
  const pincode = readCookie('PC');
  const storeName = window?.__PRELOADED_STATE__?.metaData?.name || '';
  const city = (readCookie('CT') || '').toLowerCase();
  const region = (readCookie('ZN') || '').toLowerCase();

  const hashDigest = sha256Hex(customerUUI);
  let funtionTriggered = 0;
  let hasIdentityEventFired = false;

  const triggerIdentityEvent = () => {
    if (hasIdentityEventFired) return;

    if (
      (!readCohortValueCookie('userCohortValues', storeName, 'cms') ||
        !readCookie('PC') ||
        !readCookie('CT') ||
        !readCookie('ZN') ||
        !readCookie("customerType")) &&
      funtionTriggered <= 9
    ) {
      setTimeout(() => {
        triggerIdentityEvent();
        funtionTriggered += 1;
      }, 1000);

      return;
    }
    const traits = {
      customer_pk: sha256Hex(customer_pk),
      name: sha256Hex(name?.toLowerCase()),
      email: sha256Hex(emailId?.toLowerCase()),
      mobileNumber: sha256Hex(mobileNumber),
      cleverTap_Id: cleverTapId || '',
      new_repeat_customer_flag: isNew,
      new_repeat_customer_type: isNew ? 'New' : 'Existing',
      // localStorage-driven: 'new' on the first-ever visit, 'repeat' after.
      new_repeat_visitor: getNewRepeatVisitor(),
      ...(pincode && { pincode }),
      ...(readCohortValueCookie('userCohortValues', storeName, 'cms') && {
        customer_cohort: readCohortValueCookie('userCohortValues', storeName, 'cms')
      }),
      ...(city && { city }),
      ...(region && { region })
    };
    const affiliateData = getAffiliateCookie();
    console.log('Affiliate logs: [segment.js][signedIn] cookie:', affiliateData);

    // 🔥 ALWAYS reset affiliate traits (even if no affiliateData present)
    AFFILIATE_KEYS.forEach(key => {
      traits[key] = 'NA';
    });

    // ✅ Add fresh affiliate/creator data only if available + matching channel enabled
    const medium = affiliateData?.attributed_affiliate_campaign_medium;
    const isChannelEnabled =
      medium === 'creator'
        ? isCreatorFeatureEnabled?.masterFlag
        : true;
    console.log('Affiliate logs: [segment.js][signedIn] medium/enabled:', medium, isChannelEnabled);
    if (isChannelEnabled && affiliateData && Object.keys(affiliateData).length > 0) {
      Object.assign(traits, affiliateData);
      console.log('Affiliate logs: [segment.js][signedIn] merged affiliate traits');
    }
    console.log('Affiliate logs: [segment.js][signedIn] final traits:', traits);
    amplitudeIdentify(hashDigest, traits);
    if(segmentTrackingEnabled == 'ON'){
      analytics?.identify(hashDigest, traits);
    }
    setUserDetails();
    hasIdentityEventFired = true;
  };

  triggerIdentityEvent();
} else{
  setTimeout(() => {
    const traits = {
      customer_pk: sha256Hex(''),
      name: sha256Hex(''),
      email: sha256Hex(''),
      mobileNumber: sha256Hex(''),
      cleverTap_Id: cleverTapId || '',
      new_repeat_customer_flag: true,
      new_repeat_customer_type: 'Guest',
      // localStorage-driven: a returning guest is 'repeat', not always 'new'.
      new_repeat_visitor: getNewRepeatVisitor()
    };
    const affiliateData = getAffiliateCookie();
    console.log('Affiliate logs: [segment.js][guest] cookie:', affiliateData);

    // 🔥 ALWAYS reset affiliate traits (even if no affiliateData present)
    AFFILIATE_KEYS.forEach(key => {
      traits[key] = 'NA';
    });
    // ✅ Add fresh affiliate/creator data only if available + matching channel enabled
    const medium = affiliateData?.attributed_affiliate_campaign_medium;
    const isChannelEnabled =
      medium === 'creator'
        ? isCreatorFeatureEnabled?.masterFlag
        : true;
    console.log('Affiliate logs: [segment.js][guest] medium/enabled:', medium, isChannelEnabled);
    if (isChannelEnabled && affiliateData && Object.keys(affiliateData).length > 0) {
      Object.assign(traits, affiliateData);
      console.log('Affiliate logs: [segment.js][guest] merged affiliate traits');
    }
    console.log('Affiliate logs: [segment.js][guest] final traits:', traits);
    // Align Amplitude device_id with Segment anonymousId so guest events share an identifier across both platforms,
    // and do NOT set Amplitude user_id for guests (matches Segment's null user_id behavior).
    amplitudeSetDeviceId(readCookie('segment_device_id') || '');
    amplitudeIdentify('', traits);
    if(segmentTrackingEnabled == "ON"){
      analytics?.identify(traits);
    }
  }, 1000);

  setUserDetails();
}
